import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from '@environments/environment';
import {Result} from "@domain/common/http/result";
import {first} from "rxjs/operators";
import {ParamsCartes} from "@domain/admin/frais/cartes/params-cartes";

/**
 * Service de gestion des paramètres des frais cartes
 */
@Injectable()
export class ParamsCartesService {

	/**
	 * Constructeur
	 *
	 * @param http Service HTTP
	 */
	constructor(private http: HttpClient) {}

    /**
     * Chargement des paramètres des frais cartes
     */
    loadParams(): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/ImportCA/loadParams`,null).pipe(first());
    }

    /**
     * Enregistrement des paramètres des frais cartes
     *
     * @param paramsCartes paramètres des frais cartes à enregistrer
     */
    saveParams(paramsCartes: ParamsCartes): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/ImportCA/saveParams`,paramsCartes).pipe(first());
    }
}